export const enum MerchantPaymentMethodPSPDetailTab {
    MethodLimits = 'MethodLimits',
    History = 'History',
    Info = 'Info'
};
